import React from 'react';
import { connect } from 'react-redux';
import { H1, FooterBlock } from './NutritionCourseStyles';
import * as action from '../../../actions/newYouslim';
import Navbar from '../Navigation/Navbar';
import DishReplaceModal from './DishReplaceModal';

import ResultBlock from '../UserPage/ResultsBlock';
import AddDishModal from './AddDishModal';
import DeleteConfirmPopup from '../../Common/DeleteConfirmPopup';

const NutritionCourse = React.memo(
  ({
    allTags,
    match,
    getUserMenuInCourse,
    userMenuInCourse,
    getMealsToReplaceList,
    mealsToReplaceList,
    replaceUserMenuDish,
    searchDishForReplacement,
    dishForReplacement,
    addDishToMenu,
    onDeleteDish,
  }) => {
    const [isReplaceModalOpen, setIsReplaceModalOpen] = React.useState(false);
    const [isAddDishModalOpen, setAddDishModalOpen] = React.useState(false);
    const [currentPortionId, setCurrentPortionId] = React.useState(0);
    const [currentGenerateId, setCurrentGenerateId] = React.useState(0);
    const [currentSerialNumberWeek, setCurrentSerialNumberWeek] = React.useState(0);
    const [currentSerialNumberMeal, setCurrentSerialNumberMeal] = React.useState(0);
    const [currentMealId, setCurrentMealId] = React.useState(0);
    const [addDishPosition, setAddDishPosition] = React.useState('Перекус');
    const [isDeleteModal, setIsDeleteModal] = React.useState(0);
    const [currentDishName, setCurrentDishName] = React.useState('');

    React.useEffect(() => {
      if (match && match.params && match.params.courseId) {
        getUserMenuInCourse(match.params.courseId);
      }
    }, []);

    const toggleDeleteModal = () => {
      setIsDeleteModal(!isDeleteModal);
    };

    const onPressGetReplaceDishList = async (
      meal_id,
      position_id,
      recipe_id,
      portion_id,
      generate_id,
      serial_number_week,
      serial_number_meal,
    ) => {
      setCurrentMealId(meal_id);
      setCurrentPortionId(portion_id);
      setCurrentGenerateId(generate_id);
      setCurrentSerialNumberWeek(serial_number_week);
      setCurrentSerialNumberMeal(serial_number_meal);
      await getMealsToReplaceList({
        meal_id: meal_id,
        position_id: position_id,
        user_id: match.params.id,
        recipe_id: recipe_id,
      });
      setIsReplaceModalOpen(true);
    };

    const onPressReplaceDish = React.useCallback(
      (dish_id, portionId) => {
        replaceUserMenuDish({
          portion_id: portionId || currentPortionId,
          dish_id,
          generate_id: currentGenerateId,
          serial_number_week: currentSerialNumberWeek,
          meal_id: currentMealId,
          serial_number_meal: currentSerialNumberMeal,
          closeModal: () => setIsReplaceModalOpen(false),
          courseId: match.params.courseId,
        });
      },
      [
        currentPortionId,
        currentGenerateId,
        currentSerialNumberWeek,
        currentMealId,
        currentSerialNumberMeal,
      ],
    );

    const onPressOpenAddDishModal = React.useCallback(
      (generate_id, serial_number_week, serial_number_meal, position) => {
        setCurrentGenerateId(generate_id);
        setCurrentSerialNumberWeek(serial_number_week);
        setCurrentSerialNumberMeal(serial_number_meal);
        setAddDishModalOpen(true);
        setAddDishPosition(position);
      },
      [],
    );

    const onPressOpenDeleteDishModal = React.useCallback(
      (meal_id, generate_id, serial_number_week, serial_number_meal, dish_name) => {
        setCurrentGenerateId(generate_id);
        setCurrentMealId(meal_id);
        setCurrentSerialNumberWeek(serial_number_week);
        setCurrentSerialNumberMeal(serial_number_meal);
        setCurrentDishName(dish_name);
        setIsDeleteModal(true);
        // setAddDishPosition(position);
      },
      [],
    );

    const onPressDeleteDish = React.useCallback(() => {
      onDeleteDish({
        generating_id: currentGenerateId,
        serial_number_week: currentSerialNumberWeek,
        meal_id: currentMealId,
        serial_number_meal: currentSerialNumberMeal,
        courseId: match.params.courseId,
        closeModal: () => setIsDeleteModal(false),
      });
      //     generating_id,
      // serial_number_week,
      // serial_number_meal,
      // meal_id,
      // courseId,
      // closeModal,
    }, [currentGenerateId, currentSerialNumberWeek, currentMealId, currentSerialNumberMeal]);

    const onPressAddDish = React.useCallback(
      (portion, position, dishId) => {
        addDishToMenu({
          portion_id: portion,
          dish_id: dishId,
          generating_id: currentGenerateId,
          serial_number_week: currentSerialNumberWeek,
          meal_id: currentSerialNumberMeal,
          dish_tag_id: position,
          closeModal: () => setAddDishModalOpen(false),
          courseId: match.params.courseId,
        });
      },
      [currentGenerateId, currentSerialNumberMeal, currentSerialNumberWeek],
    );

    return (
      <React.Fragment>
        <Navbar> </Navbar>
        <H1>Меню пользователя </H1>

        <ResultBlock
          usersGeneratedData={userMenuInCourse}
          dishTags={allTags}
          onPressGetReplaceDishList={onPressGetReplaceDishList}
          onPressOpenAddDishModal={onPressOpenAddDishModal}
          onPressOpenDeleteDishModal={onPressOpenDeleteDishModal}
        />
        <FooterBlock />
        <DishReplaceModal
          replaceDish={mealsToReplaceList}
          isOpen={isReplaceModalOpen}
          onClose={() => setIsReplaceModalOpen(false)}
          onReplaceDish={onPressReplaceDish}
          getDishListByName={searchDishForReplacement}
          dishes={dishForReplacement}
        />
        <AddDishModal
          replaceDish={mealsToReplaceList}
          isOpen={isAddDishModalOpen}
          onClose={() => setAddDishModalOpen(false)}
          onPressAddDish={onPressAddDish}
          getDishListByName={searchDishForReplacement}
          dishes={dishForReplacement}
          addDishPositionType={addDishPosition}
        />
        <DeleteConfirmPopup
          isOpen={isDeleteModal}
          title={currentDishName}
          isTrainingHasVideo={false}
          // warning={warningWhenDeleting}
          onDelete={onPressDeleteDish}
          onCancel={toggleDeleteModal}
        />
      </React.Fragment>
    );
  },
);

const mapStateToProps = (state) => {
  const {
    allTags,
    userTarget,
    users,
    usersGeneratedData,
    userMenuInCourse,
    mealsToReplaceList,
    dishForReplacement,
  } = state.newYouslim;
  return {
    allTags,
    usersGeneratedData,
    userTarget,
    users,
    userMenuInCourse,
    mealsToReplaceList,
    dishForReplacement,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getProductTags: (tags) => {
      dispatch(action.getProductTags(tags));
    },
    getUsers: () => {
      dispatch(action.getUsers());
    },
    setUserTarget: (data) => {
      dispatch(action.setUserTarget(data));
    },
    getGenetatorResults: (id) => {
      dispatch(action.getGenetatorResults(id));
    },
    runGenerator: (data, setIsGenerateRun) => {
      dispatch(action.runGenerator(data, setIsGenerateRun));
    },
    getUserMenuInCourse: (id) => {
      dispatch(action.getUserMenuInCourse(id));
    },
    searchDishForReplacement: (name) => {
      dispatch(action.searchDishForReplacement(name));
    },

    getMealsToReplaceList: ({ meal_id, position_id, user_id, recipe_id }) => {
      dispatch(action.getMealsToReplaceList({ meal_id, position_id, user_id, recipe_id }));
    },
    replaceUserMenuDish: ({
      portion_id,
      dish_id,
      generate_id,
      serial_number_week,
      meal_id,
      serial_number_meal,
      closeModal,
      courseId,
    }) => {
      dispatch(
        action.replaceUserMenuDish({
          portion_id,
          dish_id,
          generate_id,
          serial_number_week,
          meal_id,
          serial_number_meal,
          closeModal,
          courseId,
        }),
      );
    },
    addDishToMenu: ({
      portion_id,
      dish_id,
      generating_id,
      serial_number_week,
      meal_id,
      dish_tag_id,
      courseId,
      closeModal,
    }) => {
      dispatch(
        action.addDishToMenu({
          portion_id,
          dish_id,
          generating_id,
          serial_number_week,
          meal_id,
          dish_tag_id,
          courseId,
          closeModal,
        }),
      );
    },
    onDeleteDish: ({
      generating_id,
      serial_number_week,
      serial_number_meal,
      meal_id,
      courseId,
      closeModal,
    }) => {
      dispatch(
        action.onDeleteDish({
          generating_id,
          serial_number_week,
          serial_number_meal,
          meal_id,
          courseId,
          closeModal,
        }),
      );
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(NutritionCourse);



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/NutritionCourse/index.jsx